import { Button, Form, FormControl, FormGroup } from 'react-bootstrap';
import { memo, useCallback, useState } from 'react';
import { useTimer } from '../../../hooks/useTimer';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { Loader } from '../../../components/Loader/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { getDeleteProfileErrorSelector, getIsDeleteProfileLoadingSelector } from '../../../app/appSelectors';
import { SettingsDeleteProfileStyled } from './styled/SettingsDeleteProfileStyled';
import { deleteProfileAction } from '../../../app/appActions';

function SettingsDeleteProfile({className}: {className?: string}) {
    const { getLangPath } = useLangContext();
    const [password, setPassword] = useState('');
    const isDeleteProfileLoading = useSelector(getIsDeleteProfileLoadingSelector);
    const deleteProfileError = useSelector(getDeleteProfileErrorSelector);
    const dispatch = useDispatch();

    const handleBlockAccount = useCallback(() => {
        dispatch(deleteProfileAction(password));
    }, [dispatch, password]);

    const { startTimer, stopTimer } = useTimer(handleBlockAccount);

    const onMouseDownHandler = useCallback(() => {
        startTimer(3000);
    }, [startTimer]);

    const onMouseUpHandler = useCallback(() => {
        stopTimer();
    }, [stopTimer]);

    const onChangeHandler = useCallback((e) => {
        setPassword(e.currentTarget.value);
    }, []);

    return <SettingsDeleteProfileStyled className={className}>
        <Loader show={isDeleteProfileLoading}/>
        <p>{getLangPath('settings.delete_profile.type_password')}</p>
        <div className={'d-flex flex-1 flex-column gap-3 justify-content-between'}>
            <FormGroup>
                <FormControl isInvalid={!!deleteProfileError} value={password} type={'password'} onChange={onChangeHandler} />
                {
                    deleteProfileError && <>
                        <Form.Control.Feedback type="invalid">
                            {getLangPath(deleteProfileError)}
                        </Form.Control.Feedback>
                    </>
                }
            </FormGroup>
            <Button
                variant={'secondary'}
                onTouchStart={onMouseDownHandler}
                onTouchEnd={onMouseUpHandler}
                onMouseDown={onMouseDownHandler}
                onMouseUp={onMouseUpHandler}
                disabled={!password}
            >
                {getLangPath('settings.delete_profile.hold_to_delete')}
            </Button>
        </div>
    </SettingsDeleteProfileStyled>
}

export default memo(SettingsDeleteProfile);
